import { Handle, Position } from '@xyflow/react';

type CustomHandleProps = {
  position?: Position;
  type?: 'source' | 'target';
  disabled?: boolean;
};

export function ActionHandle({
  position = Position.Right,
  type = 'source',
  disabled,
}: CustomHandleProps) {
  return (
    <Handle
      type={type}
      position={position}
      style={{
        width: '16px',
        height: '16px',
        backgroundColor: 'transparent',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '8px',
          height: '8px',
          backgroundColor: 'white',
          border: disabled ? '1px solid #8D8D8D' : '1px solid #FF008E',
          borderRadius: '50%',
          pointerEvents: 'none',
        }}
      />
    </Handle>
  );
}

export default ActionHandle;
